// ie11 crashed with destructuring
const join = require('path').join;

export const APP_ROOT_ID = 'header-root';
export const CLIENT_DIR = join(__dirname, './client');
export const WEBPACK_MANIFEST_FILE = join(CLIENT_DIR, './manifest.json');
export const HEALTH_CHECK_PATH = '/healthcheck';
export const SUPPORTED_LOCALES = ['en-gb', 'de-de', 'ja-jp', 'el-gr', 'ru-ru', 'es-es', 'it-it'];
export const OPENBET_SUPPORTED_LOCALES = ['en-ca', 'en-ie', 'pl', 'zh-hk', 'zh-cn', 'es-es'];
